import React from "react";

const Footer = () => {
  return (
    <div className="bg-[#0B0F1F]">
      <div className="max-w-6xl  mx-auto px-4 py-10">
        <div className="h-0.5 w-full bg-gray-500"></div>
        <div className="flex flex-col space-y-4 text-gray-300 md:space-y-0 md:flex-row justify-between md:items-center mt-8">
          <div>
            <p className="">
              <div className="inline-block transform hover:scale-110 hover:-rotate-3 transition duration-300">
                <a
                  className="text-[#CF6C2F] hover:bg-[#CF6C2F] rounded-md px-2 py-1 font-semibold text-2xl  hover:text-gray-50"
                  href='./Yathin-Prakash-Kethepalli__CV.pdf'
                  target="__blank"
                  rel="noreferrer"
                >
                  Yathin Prakash Kethepalli
                </a>
              </div>
              <div className="text-lg px-2 text-gray-400">
                Copyright &copy; yathinprakashkethepalli.x
              </div>
            </p>
          </div>
          <div className="space-x-4 flex flex-row items-center text-2xl">
            <a
              className="hover:text-[#0A66C2]"
              href="https://www.linkedin.com/in/yathin-prakash-kethepalli/"
            >
              <ion-icon name="logo-linkedin"></ion-icon>
            </a>
            <a
              className="hover:text-[#E13D68]"
              href="https://www.instagram.com/yathin_017/"
            >
              <ion-icon name="logo-instagram"></ion-icon>
            </a>
            <a
              className="hover:text-[#1A8CD8]"
              href="https://twitter.com/yathin017/"
            >
              <ion-icon name="logo-twitter"></ion-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
